var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 4C20.9926 4 22 5.00736 22 6.25V17.75C22 18.9926 20.9926 20 19.75 20H4.25C3.00736 20 2 18.9926 2 17.75V6.25C2 5.00736 3.00736 4 4.25 4H19.75ZM20.5 6.25C20.5 5.83579 20.1642 5.5 19.75 5.5L18 5.5V7.5H20.5V6.25ZM20.5 9H18V11.5H20.5V9ZM20.5 13H18V15H20.5V13ZM20.5 16.5H18V18.5H19.75C20.1642 18.5 20.5 18.1642 20.5 17.75V16.5ZM16.5 18.5V5.5L7.5 5.5V18.5L16.5 18.5ZM4.25 5.5C3.83579 5.5 3.5 5.83579 3.5 6.25V7.5H6V5.5L4.25 5.5ZM6 18.5V16.5H3.5L3.5 17.75C3.5 18.1642 3.83579 18.5 4.25 18.5H6ZM6 13H3.5L3.5 15H6V13ZM6 11.5V9H3.5L3.5 11.5H6Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlights);
export default __webpack_public_path__ + "static/media/highlights.b7edcefe311beb0de1abb166f6be9f38.svg";
export { ForwardRef as ReactComponent };